import { taskTrackerRecurringTasksApi } from './taskTracker.recurringTasks.api'
import { taskTrackerSummariesApi } from './taskTracker.summaries.api'
import { taskTrackerAutomationsApi } from './taskTracker.automations.api'
import { taskTrackerBoardsApi } from './taskTracker.boards.api'
import { taskTrackerColumnsApi } from './taskTracker.columns.api'
import { taskTrackerFieldsApi } from './taskTracker.fields.api'
import { taskTrackerProjectsApi } from './taskTracker.projects.api'
import { taskTrackerTasksApi } from './taskTracker.tasks.api'
import { taskTrackerUsersApi } from './taskTracker.users.api'

export const taskTrackerApi = {
  ...taskTrackerProjectsApi,
  ...taskTrackerBoardsApi,
  ...taskTrackerColumnsApi,
  ...taskTrackerFieldsApi,
  ...taskTrackerTasksApi,
  ...taskTrackerAutomationsApi,
  ...taskTrackerUsersApi,
  ...taskTrackerSummariesApi,
  ...taskTrackerRecurringTasksApi,
}
